/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: reorder-Widget - Reorganisation der Reihenfolge einer Liste
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "fields": [
    {
        "id": "client",
        "length": 80,
        "label": "Client",
        "unitLabel": "",
        "description": "Client",
        "placeholder": "",
        "widget": "reorder",
        "maxItems": 3,
        "visibleItems": 4,
        "group": null,
        "value": "",
        "enums": []
        "validation": null,
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im reorder-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes (hier keine Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel    - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier keine Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "reorder" belegt
 * maxItems     - Maximale Anzahl an auswählbaren Werten/Zeichen
 * visibleItems - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktuelle Auswahl die in der linken Liste angezeigt werden
 * enums         - Alle Auswahlmöglichkeiten
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * validationState   - Zustand der Validierung (hier ohne Bedeutung)
 * validationMessage - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as appActions from "../../../../store/actions/appActions";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-material.css'


class Reorder extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.gridReorderApi = null;

        this.maxItems = -1;
        this.visibleItems = 5;

        this.rowHeight = 40;
        this.headerHeight = this.rowHeight;
    }

    /*==========================================================================
     *
     * RENDER - SECTION
     *
     *==========================================================================*/
    render() {
        if (this.debug) console.log("Reorder:render()")

        if (this.props.field.hasOwnProperty('maxItems')) {
            this.maxItems = this.props.field.maxItems;
        }

        if (this.props.field.hasOwnProperty('visibleItems')) {
            this.visibleItems = this.props.field.visibleItems;
        }

        const columnsDefsReorder = [
            {
                headerName: this.props.field.label,
                field: "label_all",
                width: (window.innerWidth / 2 - 100),
                checkboxSelection: false,
                suppressMenu: true,
                rowDrag: true
            },
        ];

        // Column Definitions
        const defaultColDef = {
            sortable: false,
            editable: false,
            filter: false,
            resizable: false,
            enableValue: false,
            enableRowGroup: false,
            enablePivot: false
        };

        const onGridReorderReady = (params) => {
            if (this.debug) console.log('Reorder:onGridReady()', this.props.value);

            this.gridReorderApi = params.api;
        };

        const onRowDragEnd = () => {
            let selected = [];
            this.gridReorderApi.forEachNode(function (node) {
                selected.push(node.data.index)
            });
            this.props.onSelect(selected);
        };

        let rowDataReorder = [];
        this.props.field.enums.forEach(function (row, index) {
            rowDataReorder.push({ ...row, index: index });
        });

        // calculate height
        let height = this.visibleItems * this.rowHeight + this.headerHeight + 1;

        return (
            <div className="w-full flex " style={{ height: height + 'px' }}>
                <div className="w-full ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridReorder"
                        onGridReady={onGridReorderReady}

                        // Column
                        columnDefs={columnsDefsReorder}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={rowDataReorder}
                        rowHeight={this.rowHeight}
                        rowSelection={"multiple"}
                        rowMultiSelectWithClick={true}
                        onRowDragEnd={onRowDragEnd}
                        rowDragManaged={true}

                        // Header
                        headerHeight={this.headerHeight}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Reorder);